import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { PRIMARY_BUTTON_CONTENT } from '@sportninja/common/constants/buttonColors'

/**
 * The house segmented toggle: antd `Segmented` on the dark theme.
 *
 * Lifted from `RegistrationSetup/forms/Payments/ProcessingFees` — the "League
 * Absorbs It / Registrant Pays It" control — which had already worked out the
 * dark-theme treatment (SECONDARY_200 track, PRIMARY selected pill with dark
 * label, 34px line-height). Division Setup › Team Payments was the second surface
 * to need it, and Team Budget's Add Player Slots (Open Player Slots / Reserved
 * Player Slots / Player Finder Slots) the third, so it lives here rather than
 * inside one feature.
 *
 * The selected label reads `PRIMARY_BUTTON_CONTENT`: it sits on a
 * `colors.PRIMARY` fill, whose content colour differs by tenant.
 */
export const segmentedToggleStyle = css`
  align-self: flex-start;
  &.ant-segmented {
    background-color: ${colors.SECONDARY_200};
    padding: 3px;
    border-radius: 8px;
  }
  .ant-segmented-item {
    color: ${colors.NEUTRAL_30};
    transition: color 0.15s;
    border-radius: 6px;
  }
  .ant-segmented-item:hover:not(.ant-segmented-item-disabled) {
    color: ${colors.WHITE};
  }
  .ant-segmented-item-selected {
    background-color: ${colors.PRIMARY} !important;
    color: ${PRIMARY_BUTTON_CONTENT.text} !important;
    font-weight: 600;
  }
  .ant-segmented-item-disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
  .ant-segmented-item-label {
    line-height: 34px;
    padding: 0 20px;
  }
`
